import { Box, useMediaQuery } from "@material-ui/core";
import BigNumber from "bignumber.js";
import { ethers } from "ethers";
import { useEffect, useState } from "react";
import InterestRateFactory from "src/assets/abis/poolMonitoring/InterestRateFactory.json";
import { useProviderContext } from "src/ether-utils/context/providerContext";
import { base27 } from "src/hooks/useContractEditPool";
import { toFixed } from "src/services/utils";
import FigureText from "src/view/PoolMonitoring/Overview/AssetConfigOption/components/FigureText";

export default function SetReserveInterestRateStrategyAddressItem({ data }) {
  const { currentProvider } = useProviderContext();
  const matches = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  const [utilizationOptimal, setUtilizationOptimal] = useState(undefined);
  const [slope1, setSlope1] = useState(undefined);
  const [slope2, setSlope2] = useState(undefined);

  async function getData() {
    try {
      const _contract = new ethers.Contract(data.rateStrategyAddress, InterestRateFactory, currentProvider);
      const _utilizationOptimal = await _contract.OPTIMAL_UTILIZATION_RATE();
      const _slope1 = await _contract.variableRateSlope1();
      const _slope2 = await _contract.variableRateSlope2();
      setUtilizationOptimal(BigNumber(_utilizationOptimal._hex).div(base27).toFixed());
      setSlope1(BigNumber(_slope1._hex).div(base27).toFixed());
      setSlope2(BigNumber(_slope2._hex).div(base27).toFixed());
    } catch (error) {
      setUtilizationOptimal(undefined);
      setSlope1(undefined);
      setSlope2(undefined);
    }
  }

  useEffect(() => {
    if (currentProvider && data.rateStrategyAddress) getData();
    else {
      setUtilizationOptimal(undefined);
      setSlope1(undefined);
      setSlope2(undefined);
    }
  }, [currentProvider, data]);

  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center" flexWrap="wrap">
      <FigureText
        sx={{ display: "flex", alignItems: "baseline" }}
        title="Symbol"
        value={data.symbol}
        mr={matches ? 0 : 8}
        justifyContent={matches ? "space-between" : "flex-start"}
        width={matches ? "100%" : "inherit"}
        style={{ marginBottom: 15 }}
      />
      {utilizationOptimal && (
        <FigureText
          sx={{ display: "flex", alignItems: "baseline" }}
          title="Utilization Optimal"
          value={`${utilizationOptimal * 100}%`}
          mr={matches ? 0 : 8}
          justifyContent={matches ? "space-between" : "flex-start"}
          width={matches ? "100%" : "inherit"}
          style={{ marginBottom: 15 }}
        />
      )}
      {slope1 && (
        <FigureText
          sx={{ display: "flex", alignItems: "baseline" }}
          title="Slope1"
          value={`${toFixed(slope1 * 100, 2)}%`}
          mr={matches ? 0 : 8}
          justifyContent={matches ? "space-between" : "flex-start"}
          width={matches ? "100%" : "inherit"}
          style={{ marginBottom: 15 }}
        />
      )}
      {slope2 && (
        <FigureText
          sx={{ display: "flex", alignItems: "baseline" }}
          title="Slope2"
          value={`${toFixed(slope2 * 100, 2)}%`}
          mr={matches ? 0 : 8}
          justifyContent={matches ? "space-between" : "flex-start"}
          width={matches ? "100%" : "inherit"}
          style={{ marginBottom: 15 }}
        />
      )}
    </Box>
  );
}
